// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_refunds_shipping_body = /** @type {(inputs: {}) => string} */ () => {
	return `Return shipping costs are the responsibility of the customer, unless the item is defective or incorrect.`
};

const el_refunds_shipping_body = /** @type {(inputs: {}) => string} */ () => {
	return `Τα μεταφορικά επιστροφής βαρύνουν τον πελάτη, εκτός αν το προϊόν είναι ελαττωματικό ή λανθασμένο.`
};

const ru_refunds_shipping_body = /** @type {(inputs: {}) => string} */ () => {
	return `Расходы на обратную доставку несёт покупатель, за исключением случаев, когда товар неисправен или отправлен по ошибке.`
};

const he_refunds_shipping_body = /** @type {(inputs: {}) => string} */ () => {
	return `עלות משלוח ההחזרה חלה על הלקוח, אלא אם המוצר פגום או שגוי.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunds_shipping_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunds_shipping_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunds_shipping_body", locale)
	if (locale === "en") return en_refunds_shipping_body(inputs)
	if (locale === "el") return el_refunds_shipping_body(inputs)
	if (locale === "ru") return ru_refunds_shipping_body(inputs)
	if (locale === "he") return he_refunds_shipping_body(inputs)
	return "refunds_shipping_body"
};